import React from "react";

const CreditCard = ({ card }) => {
  return (
    <div className="credit-card">
      <img src={card.image} alt={`${card.name} Card`} className="card-image" />
      <div className="card-details">
        <h2>{card.name}</h2>
        <div className="item_flex">
          <p>APR: {card.apr}</p>
          <p>Annual Fee: {card.annualFee}</p>
          <p>Credit Score: {card.creditScore}</p>
        </div>
        <p>Reward: {card.reward}</p>
        <div className="item_flex">
          <p>Limit: {card.limit}</p>
          <p>Average: {card.averageLimit}</p>
        </div>
        <div className="card-buttons">
          <button className="experian-button">Experian</button>
          <button className="more-info-button">More Info</button>
          <button className="apply-button">Apply</button>
        </div>
      </div>
    </div>
  );
};

export default CreditCard;
